import { useWallet } from '@solana/wallet-adapter-react';
import React, { useContext, useEffect, useState } from 'react';
import { AuthorizationContext } from '../../contexts/auth.context';
import { WizardContext } from '../../contexts/story.context';
import { Pages, LEGAL_WALLETS } from '../../utils/constants';
import { useNavigate } from 'react-router-dom';

const IMAGES = [
  'https://i.imgur.com/rq78rvr.png',
  'https://i.imgur.com/fMMZafs.png',
  'https://i.imgur.com/eonJNix.png',
  'https://i.imgur.com/v8CAH5R.png',
];

const bgImg = IMAGES[Math.floor(Math.random() * IMAGES.length)];

const ConnectWalletPrompt = ({ onRequestConnectWallet, loading }) => {
  const wallet = useWallet();
  const isLegalWallet = wallet && LEGAL_WALLETS.includes(wallet.publicKey?.toString());

  React.useEffect(() => {
    const button = document.querySelector('.wallet-adapter-button');
    if (button) {
      button.click();
    }
  }, []);
  return (
    <div className="container-fluid">
      <div className="min-vh-100 bg-100 row">
        <div className="d-none d-lg-block position-relative col-6">
          <div
            className="bg-holder"
            style={{
              backgroundImage: `url("${bgImg}")`,
              backgroundPosition: '50% 30%',
            }}
          />
        </div>
        <div className="px-sm-0 align-self-center mx-auto py-5 col-md-6 col-sm-10">
          <div className="g-0 justify-content-center row">
            <div className="col-xxl-6 col-xl-8 col-lg-9">
              <div className="card border-0">
                <div className="p-4 mx-auto card-body">
                  <div className="d-flex align-items-center">
                    <div className="text-center">
                      <img
                        className="d-block mx-auto mb-4 shadow rounded"
                        src="https://i.imgur.com/menWcho.png"
                        alt="cat"
                        width={100}
                      />
                      <button
                        onClick={onRequestConnectWallet}
                        className="wallet-adapter-button wallet-adapter-button-trigger"
                        style={{
                          backgroundColor: !loading && isLegalWallet ? '#ffdf58' : '',
                          color: !loading && isLegalWallet ? '#000' : '',
                        }}
                        tabIndex={0}
                        type="button"
                        disabled={!isLegalWallet || loading}
                      >
                        {loading ? 'Loading...' : isLegalWallet ? 'ENTER' : 'Wallet Not Allowed'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const SelectionPage = () => {
  const wallet = useWallet();
  const { signIn } = useContext(AuthorizationContext);
  const { dispatch } = useContext(WizardContext);
  const [loading, setLoading] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    if (wallet) {
      wallet.connect();
    }
  }, [wallet]);

  const selectPage = async character => {
    if (loading) return;

    setLoading(true);
    try {
      await signIn();
      dispatch({ type: 'SET_CHARACTER', character });
      dispatch({ type: 'SET_STEP', step: 2 });
      navigate(character.path);
    } catch (e) {
      console.log(e);
    }

    setLoading(false);
  };

  return (
    <ConnectWalletPrompt onRequestConnectWallet={() => selectPage(Pages[0])} loading={loading} />
  );
};

export default SelectionPage;
